<div class="search-bar">
  <mat-form-field appearance="outline">
    <mat-icon matPrefix>search</mat-icon>
    <mat-label>Search</mat-label>
    <input matInput value="">
  </mat-form-field>
</div>
